module.exports = __webpack_public_path__ + "img/logo.dbeea861.png";